import { combineReducers } from 'redux';
import battleReducer from './battle';

const rootReducer = combineReducers({
  battle: battleReducer,
});

export default rootReducer;
